export { default } from './BorrowingStatus';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingStatus/index.js